export default __webpack_public_path__ + "static/media/kid24.b62de458.jpg";